import { Grid, TextField } from '@mui/material';
import _ from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import { AutocompleteSelector } from '../AutocompleteSelector/AutocompleteSelector';

const fields = [
  'addressStreet',
  'addressExtNumber',
  'addressColony',
  'addressZip',
  'addressState',
  'addressCity',
];

export const DirectionFields = ({
  values,
  catalogCountries,
  catalogStates,
  catalogCities,
  spacing = 2.5,
  required = false,
  onChange = () => {},
  onError = () => {},
}) => {
  const stateRef = useRef(null);
  const cityRef = useRef(null);

  const { addressCountry, addressState } = values;

  // ----------- errores internos -----------
  const [errors, setErrors] = useState({});

  // ----------- detect autocomplete changes -----------
  useEffect(() => {
    if (typeof addressCountry !== 'object' || _.isEmpty(addressCountry)) return;
    console.log(`Pais cambio a: ${addressCountry.value}`);
    stateRef.current?.makeRequest({
      country_key: addressCountry.value,
    });
  }, [addressCountry]);

  useEffect(() => {
    if (typeof addressState !== 'object' || _.isEmpty(addressState)) return;
    console.log(`Estado cambio a: ${addressState.value}`);
    cityRef.current?.makeRequest({
      state_key: addressState.value,
    });
  }, [addressState]);

  // ----------- validación interna -----------
  const validateField = useCallback((key, value, mustRequire) => {
    if (mustRequire && (value === undefined || value === null || value === '')) {
      return `Requerido`;
    }
    if (key === 'addressZip' && value && value.length > 8) {
      return 'Máximo de 8 caracteres.';
    }
    return null;
  }, []);

  useEffect(() => {
    const currentValues = _.omit(values, ['addressCountry', 'addressCountryName']);
    // const anyFilled = Object.values(currentValues).some(
    //   (val) => val !== '' && val !== null && val !== undefined
    // );
    const newErrors = {};
    fields.forEach((field) => {
      newErrors[field] = validateField(field, currentValues[field], required);
    });
    setErrors(newErrors);
  }, [required, validateField, values]);

  useEffect(() => {
    onError?.(Object.values(errors).some((err) => err !== null));
  }, [errors]);

  const handleChange = (key, value) => {
    onChange(key, value);
  };

  return (
    <Grid container spacing={spacing} className="mb-32">
      <Grid xs={12} item>
        <Grid spacing={spacing} container>
          <Grid xs={12} md={8} item>
            <TextField
              label="Calle"
              variant="outlined"
              fullWidth
              value={values.addressStreet || ''}
              onChange={(e) => handleChange('addressStreet', e.target.value)}
              error={!!errors?.addressStreet}
              helperText={errors?.addressStreet}
            />
          </Grid>
          <Grid xs={6} md={2} item>
            <TextField
              label="No. Exterior"
              variant="outlined"
              fullWidth
              value={values.addressExtNumber || ''}
              onChange={(e) => handleChange('addressExtNumber', e.target.value)}
              error={!!errors?.addressExtNumber}
              helperText={errors?.addressExtNumber}
            />
          </Grid>
          <Grid xs={6} md={2} item>
            <TextField
              label="No. Interno"
              variant="outlined"
              fullWidth
              value={values.addressIntNumber || ''}
              onChange={(e) => handleChange('addressIntNumber', e.target.value)}
              error={!!errors?.addressIntNumber}
              helperText={errors?.addressIntNumber}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid xs={12} item>
        <Grid spacing={spacing} container>
          <Grid xs={8} md={9} item>
            <TextField
              label="Colonia"
              variant="outlined"
              fullWidth
              value={values.addressColony || ''}
              onChange={(e) => handleChange('addressColony', e.target.value)}
              error={!!errors?.addressColony}
              helperText={errors?.addressColony}
            />
          </Grid>
          <Grid xs={4} md={3} item>
            <TextField
              label="C.P."
              type="number"
              variant="outlined"
              fullWidth
              value={values.addressZip || ''}
              onChange={(e) => handleChange('addressZip', e.target.value)}
              error={!!errors?.addressZip}
              helperText={errors?.addressZip}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid xs={12} item>
        <Grid spacing={spacing} container>
          <Grid xs={12} md={4} item>
            <AutocompleteSelector
              className="w-full"
              request={catalogCountries}
              id="scopes-data-suspen"
              valueKey="value"
              labelKey="label"
              ChipProps={{ color: 'secondary' }}
              value={values.addressCountry || null}
              onChange={(newValue) => {
                handleChange('addressCountry', newValue);
                onChange('addressState', null);
                onChange('addressCity', null);
              }}
              disableClearable
              inputProps={{
                fullWidth: true,
                variant: 'outlined',
                label: 'País',
                placeholder: 'Seleccionar una opción',
                error: !!errors?.addressCountry,
                helperText: errors?.addressCountry,
              }}
            />
          </Grid>
          <Grid xs={12} md={4} item>
            <AutocompleteSelector
              className="w-full"
              request={catalogStates}
              autoFetch={false}
              id="scopes-data-suspen"
              valueKey="value"
              labelKey="label"
              ChipProps={{ color: 'secondary' }}
              ref={stateRef}
              value={values.addressState || null}
              onChange={(newValue) => {
                handleChange('addressState', newValue);
                onChange('addressCity', null);
              }}
              inputProps={{
                fullWidth: true,
                variant: 'outlined',
                label: 'Estado',
                placeholder: 'Seleccionar una opción',
                error: !!errors?.addressState,
                helperText: errors?.addressState,
              }}
            />
          </Grid>
          <Grid xs={12} md={4} item>
            <AutocompleteSelector
              className="w-full"
              request={catalogCities}
              autoFetch={false}
              id="scopes-data-suspen"
              valueKey="value"
              labelKey="label"
              ChipProps={{ color: 'secondary' }}
              ref={cityRef}
              value={values.addressCity || null}
              onChange={(newValue) => handleChange('addressCity', newValue)}
              inputProps={{
                fullWidth: true,
                variant: 'outlined',
                label: 'Alcaldía o Municipio',
                placeholder: 'Seleccionar una opción',
                error: !!errors?.addressCity,
                helperText: errors?.addressCity,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
